/** IAD death certificate workflow — API scope + frame_data keys */

export const DEATH_CERT_API_PHASE = 'iad';
export const DEATH_CERT_STEP_ID = 'iad-1';

export const DEATH_CERT_FRAME_DATA = {
  orderForm: 'iad-death-cert-244',
  orders: 'iad-death-cert-21',
  received: 'iad-death-cert-22',
  distribution: 'iad-death-cert-23',
  completion: 'iad-death-cert-24',
} as const;

/** Stored in settlement_documents.description for filtering */
export const DEATH_CERT_DOC = {
  orderReceipt: 'death-cert-doc:244-order-receipt',
  certifiedScan: 'death-cert-doc:22-certified-scan',
  distributionProof: 'death-cert-doc:23-distribution-proof',
} as const;

export function deathCertRoute(path: string, estateId: string | undefined): string {
  const base = path.startsWith('/') ? path : `/${path}`;
  return estateId ? `${base}/${estateId}` : base;
}
